import { useEffect, useState } from 'react';
import { IApiCallStatus, IError, qa } from '../common';
import { IQa } from '.';
import { fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const useQa = () => {
  const [q, setQ] = useState<IQa[]>([]);
  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();

  useEffect(() => {
    qa().then(
      fold<IError, IQa[], void>(
        flow(console.error, () => setApiCallStatus(false)),
        flow(setQ, () => setApiCallStatus(true))
      )
    );
  }, []);

  return { qa: q, qaApiStatus: apiCallStatus };
};
